import { render } from "./lost-connection-warning.vue?vue&type=template&id=07007015&ts=true"
import script from "./lost-connection-warning.ts?vue&type=script&lang=ts&external"
export * from "./lost-connection-warning.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__